export default {
  form: {
    address: {
      delivery: {
        placeholder: 'Pesquisar morada de entrega',
      },
      placeholder: 'Introduza a morada para encontrar a loja mais próxima',
    },
  },
  toasts: {
    failed_to_load_stores: 'Falha ao carregar lojas, por favor atualize a página',
  },
  errors: {
    no_delivery_companies: 'Entrega não disponível para esta morada',
    delivery_not_available: 'Infelizmente, não oferecemos entrega de momento',
    location_unavailable:
      'Não foi possível aceder à sua localização, ative as permissões ou introduza a morada manualmente',
    location_lookup_failed: 'Não foi possível localizar a sua morada, tente novamente',
    address_suggestions_unavailable: 'Não foi possível carregar as sugestões de morada.',
  },
  buttons: {
    use_current_location: 'Usar a minha localização atual',
    locating: 'A localizar…',
    retry: 'Tentar novamente',
  },
};
